const config = {
  apiKey: 'AIzaSyDu9QVSgGeptFcAyPHFsv2BvSvsmfGqC2U',
  authDomain: 'simple-contacts-a5e70.firebaseapp.com',
  projectId: 'simple-contacts-a5e70',
  storageBucket: 'simple-contacts-a5e70.appspot.com',
  messagingSenderId: '651416275832',
  appId: '1:651416275832:web:3a51b0757e3c268282568d',
  measurementId: 'G-J62DQ7GGR3',
}
export default config
